/*
 *  Bot Theme Type definitions and meta-information
 * */

/*
 * Base for all Bot Themes Type Definitions
 * */

export class BotThemeTypeDef {
  constructor() {
    this.type = '';
    this.category = '';
    this.title = '';
    this.description = '';
    this.defaultName = '';
    this.icon = 'lightbulb-on-20';
    this.helpUrl = '';
    this.props = [];
  }
}

export const emptyBotTheme = new BotThemeTypeDef();

// Common Bot Theme props, applicable for all Bot Themes
export const commonBotThemeProps = [
  // TODO
];

/*
 * Bot Theme Type Definition: Default Bot Theme
 * */
export class BotThemeTypeDefault extends BotThemeTypeDef {
  constructor() {
    super();
    this.type = 'default';
    this.title = 'Bot Theme';
    this.description = 'Bot Theme';
    this.defaultName = 'Bot Theme';
    this.helpUrl = '/help/kb/standard';
    this.icon = 'lightbulb-on-20';
    this.props = commonBotThemeProps.concat([
      { group: 'hidden', title: 'Component Name', name: 'componentName', type: 'string', default: 'enegelai-bot', hidden: true },
      { group: 'title', title: 'Title', name: 'title', type: 'stringLong', default: '', description: '' },
      { group: 'title', title: 'Logo', name: 'logoUrl', type: 'logo', default: '', description: '' },
      { group: 'header', title: 'Header Background', name: 'cssVariables.--enegelai-bot-header-background', type: 'color', default: 'rgba(0, 208, 117, 1)' },
      { group: 'header', title: 'Header Color', name: 'cssVariables.--enegelai-bot-header-color', type: 'color', default: 'rgba(255, 255, 255, 1)' },
      { group: 'messageUser', title: 'Message from User Background', name: 'cssVariables.--enegelai-bot-message-user-background', type: 'color', default: 'rgba(250, 250, 250, 1)' },
      { group: 'messageUser', title: 'Message from User Color', name: 'cssVariables.--enegelai-bot-message-user-color', type: 'color', default: 'rgba(0, 0, 0, 1)' },
      { group: 'messageBot', title: 'Message from Bot Background', name: 'cssVariables.--enegelai-bot-message-bot-background', type: 'color', default: 'rgba(250, 250, 250, 1)' },
      { group: 'messageBot', title: 'Message from Bot Color', name: 'cssVariables.--enegelai-bot-message-bot-color', type: 'color', default: 'rgba(0, 0, 0, 1)' },
      { group: 'anchor', title: 'Anchor Background', name: 'cssVariables.--enegelai-bot-anchor-background', type: 'color', default: 'rgba(0, 208, 117, 1)' },
      { group: 'anchor', title: 'Anchor Border Color', name: 'cssVariables.--enegelai-bot-anchor-border-color', type: 'color', default: 'rgba(0, 208, 117, 1)' },
      { group: 'form', title: 'Form Submit Background', name: 'cssVariables.--enegelai-bot-form-submit-background', type: 'color', default: 'rgba(0, 208, 117, 1)' },
      { group: 'form', title: 'Form Submit Border', name: 'cssVariables.--enegelai-bot-form-submit-border', type: 'color', default: 'rgba(0, 208, 117, 1)' },
      { group: 'popup', title: 'Popup Min Height', name: 'cssVariables.--enegelai-bot-popup-min-height', type: 'string', default: '60px' },
    ]);
    this.propsByName = {};
    this.propsByGroup = {};
    this.props.map((p) => {
      this.propsByName[p.name] = p;
      const pGroup = p?.group || 'default';
      if (pGroup !== 'hidden') {
        if (!this.propsByGroup[pGroup]) {
          this.propsByGroup[pGroup] = [];
        }
        this.propsByGroup[pGroup].push(p);
      }
    });
    this.propGroups = [
      { name: 'title', title: 'Title and Logo', description: '', props: this.propsByGroup['title'] },
      { name: 'header', title: 'Header', description: '', props: this.propsByGroup['header'] },
      { name: 'messageUser', title: 'Message from User', description: '', props: this.propsByGroup['messageUser'] },
      { name: 'messageBot', title: 'Message from Bot', description: '', props: this.propsByGroup['messageBot'] },
      { name: 'anchor', title: 'Anchor', description: '', props: this.propsByGroup['anchor'] },
      { name: 'form', title: 'Form', description: '', props: this.propsByGroup['form'] },
      { name: 'popup', title: 'Popup', description: '', props: this.propsByGroup['popup'] },
    ];
  }
}

// All known Bot Theme Type Defs by type
export const BOT_THEME_TYPE_DEFS = {
  default: new BotThemeTypeDefault(),
};

// Meta-information about all known KB Types
export const BOT_THEME_TYPE_META = Object.values(BOT_THEME_TYPE_DEFS).map((x) => {
  return {
    type: x.type,
    title: x.title,
    description: x.description,
    helpUrl: x.helpUrl,
    icon: x.icon,
  };
});

export function getBotThemeTypeDef(botThemeType) {
  return botThemeType in BOT_THEME_TYPE_DEFS ? BOT_THEME_TYPE_DEFS[botThemeType] : emptyBotTheme;
}

